import { Form, Grid } from "antd";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { useGetTopupItemDetailsQuery } from "src/store/apis/Topup";
import { RootState } from "src/store";
import BannerHero from "../TopupListing/components/BannerHero/BannerHero";
import TopupDetailsWeb from "./layouts/TopupDetails.web";
import TopupDetailsMob from "./layouts/TopupDetails.mob";
import { TopupDetailsProvider } from "./context/TopupDetailsContext";
import { getTotalChargeFromAmount } from "./utils";

const TopupDetailsComponent = withConditionalComponent(TopupDetailsWeb, TopupDetailsMob);

export default function TopupDetails() {
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const { code } = useParams();
  const { i18n } = useTranslation();
  const { data, isFetching } = useGetTopupItemDetailsQuery({ code, page: 1, pageSize: 100, lang: i18n.language });
  const item = data?.[0];
  const [form] = Form.useForm();
  const redeemFactor = useSelector((state: RootState) => state.client.userDetails.redeemFactor) ?? 0;

  const handleValuesChange = (changedValues: { getAmount?: number }) => {
    if ("getAmount" in changedValues) {
      const amount = changedValues.getAmount ?? 0;
      const totalCharge = getTotalChargeFromAmount(item?.serviceChargeList!, amount);
      const payPoints = totalCharge ? Math.ceil(totalCharge * redeemFactor) : undefined;
      form.setFieldValue("payAmount", totalCharge);
      form.setFieldValue("payPoints", payPoints);
      form.validateFields(["payPoints"]).catch(() => {});
    }
  };

  return (
    <TopupDetailsProvider value={{ item, isFetching }}>
      <Form form={form} component={false} onValuesChange={handleValuesChange}>
        <div className="flex h-full flex-col min-h-[80vh] bg-background-minimal">
          <div className="from-primary-dark to-primary-semilight py-15 relative relative min-h-52 w-full overflow-hidden bg-gradient-to-r px-5 md:px-20">
            <div className="pointer-events-none absolute end-0 top-0 h-full w-16 text-icon-inverted md:w-64">
              <BannerHero />
            </div>
          </div>
          <div className="z-20">
            <TopupDetailsComponent trigger={isLargeScreen} />
          </div>
        </div>
      </Form>
    </TopupDetailsProvider>
  );
}
